import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
  
function MinimalLayout ({ children }) {
    const { pathname } = useLocation();

    useEffect(() => {
      window.scrollTo(0, 0);
    }, [pathname]);
  
    return (
        <div className="minimal-layout">
            {children}
        </div>
    )
}

export default MinimalLayout;
